export class Money {
	constructor(
	public eth: number = 0,
	public usd: number = 0,
	public gli?: number) {}
}